import { Link } from 'react-router-dom';

/**
 * Back-to-home button for tool pages.
 *
 * Lives top-left of each tool's header. On mobile (no hover), the accent
 * color shows by default so it visually matches the tool. On desktop, it
 * brightens on hover.
 */
export function HomeButton({ accentColor = '#8B5CF6' }) {
  return (
    <Link
      to="/"
      aria-label="Back to NerdStack home"
      title="Back to NerdStack"
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 48,
        height: 48,
        borderRadius: 14,
        border: `1.5px solid ${accentColor}66`,
        background: `${accentColor}24`,
        color: accentColor,
        textDecoration: 'none',
        cursor: 'pointer',
        transition: 'all 0.15s ease',
        flexShrink: 0,
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.background = `${accentColor}3D`;
        e.currentTarget.style.borderColor = `${accentColor}99`;
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.background = `${accentColor}24`;
        e.currentTarget.style.borderColor = `${accentColor}66`;
      }}
    >
      <svg
        width="26"
        height="26"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="3.6"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <path d="M19 12H5" />
        <path d="M12 19l-7-7 7-7" />
      </svg>
    </Link>
  );
}
